<template>
  <div class="max-w-7xl mx-auto mb-5">
    <div class="pointer-events-auto overflow-hidden rounded-lg bg-indigo-600 shadow-lg ring-1 ring-black ring-opacity-5 mb-4 w-full">
      <div class="p-4">
        <div class="flex flex-col lg:flex-row lg:items-center gap-3">
          <div class="flex items-start flex-1 min-w-0">
            <div class="flex-shrink-0">
              <SparklesIcon class="w-5 h-5 text-gray-100" />
            </div>
            <div class="ml-2 min-w-0">
              <p class="text-sm font-bold text-white">Ready for the MTP?</p>
              <p class="text-sm text-indigo-100">
                Prepare with our new Entrance Exam, Practical, MANDEX, and Interview Reviewer.
              </p>
            </div>
          </div>
          <div class="flex lg:flex-shrink-0 lg:justify-end">
            <button
              type="button"
              @click="$emit('view')"
              class="w-full lg:w-auto whitespace-nowrap rounded-md bg-white px-4 py-2 text-sm font-semibold text-indigo-700 shadow-sm hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-white"
            >
              Test Your Readiness
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SparklesIcon } from "@heroicons/vue/outline";

export default {
  components: { SparklesIcon },
  emits: ["view"],
};
</script>
